import React from 'react';
import styled from 'styled-components';
import Button from 'components/Button';

const DialogOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const DialogContent = styled.div`
  background: white;
  padding: 32px;
  border-radius: 12px;
  width: 480px;
  text-align: center;
`;

const IconWrapper = styled.div`
  margin-bottom: 32px;
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    width: 147px;
    height: 193px;
  }
`;

const Title = styled.div`
  font-size: 18px;
  font-weight: 500;
  color: #101828;
  margin-bottom: 32px;
  line-height: 1.4;
`;

const ButtonGroup = styled.div`
  display: flex;
  gap: 12px;
  justify-content: center;
`;

const ConfirmationDialog = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  icon,
  title = "Confirmation",
  confirmText = "Confirm",
  cancelText = "Cancel",
  collegeName 
}) => {
  if (!isOpen) return null;

  return (
    <DialogOverlay>
      <DialogContent>
        <IconWrapper>
          {icon}
        </IconWrapper>
        <Title>{title}</Title>
        <ButtonGroup>
          <Button.Secondary text={cancelText} onClick={onClose} />
          <Button.Primary text={confirmText} onClick={onConfirm} />
        </ButtonGroup>
      </DialogContent>
    </DialogOverlay>
  );
};

export default ConfirmationDialog;
